import React from "react";
import RecallSettings from "./RecallSettings";
import RecallTimings from "./RecallTimings";

function RecallsTab() {
    return (
        <>
            <div className="card-padding">
                <RecallSettings/>
                <RecallTimings/>
            </div>
        </>
    );
}

export default RecallsTab;
